import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentAllListItemContentWireframe from './VeltNotificationsPanelContentAllListItemContentWireframe/VeltNotificationsPanelContentAllListItemContentWireframe';
import VeltNotificationsPanelContentAllListItemLabelWireframe from './VeltNotificationsPanelContentAllListItemLabelWireframe/VeltNotificationsPanelContentAllListItemLabelWireframe';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltNotificationsPanelContentAllListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllListItemWireframe.Label = VeltNotificationsPanelContentAllListItemLabelWireframe;
VeltNotificationsPanelContentAllListItemWireframe.Content = VeltNotificationsPanelContentAllListItemContentWireframe;
export default VeltNotificationsPanelContentAllListItemWireframe;
